<template>
  <div class="root">
    <Background />
    <img
      src="@/assets/images/flourish-logotipo.png"
      alt="flourish logotipo"
      width="100"
      height="40"
      class="flourish-logotipo"
    />
    <transition name="blur">
      <div class="content" :class="{ behindModal: showModal }">
        <div class="result-box">
          <div class="questionsAndReward">
            <span class="title">Questions</span>
            <span class="text">{{ performance }}</span>
          </div>
          <div class="questionsAndReward">
            <span class="title">Reward</span>
            <div class="reward">
              <span class="text">{{ reward }}</span>
              <img
                src="@/assets/images/flourish-coin-darker.svg"
                width="20"
                height="20"
                alt=""
                class="coin"
              />
            </div>
          </div>
        </div>
        <div class="quote-section">
          <span class="quote"
            >“Being rich is having money; being wealthy is having time.”</span
          >
          <span class="author">— Margaret Bonnano</span>
        </div>
      </div>
    </transition>

    <button @click="goToFlourish()" class="confirm footer lighter">
      Go to Flourish App
    </button>

    <div class="modal" v-if="showModal"></div>

    <transition name="slide-bottom">
      <div class="feedback" v-if="showModal">
        <span class="title">Would you play the Trivia Game again?</span>
        <ul>
          <li
            @click="playAgainSelection(index)"
            v-for="(option, index) in wouldPlayAgainOptions"
            :key="index"
            :class="{
              isSelected: option.isSelected,
            }"
          >
            {{ option.option }}
          </li>
        </ul>
        <button
          @click="closeModal()"
          class="outline modal-button"
          :class="{ disabled: !canCloseModal }"
          :disabled="!canCloseModal"
        >
          Close
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import Background from "../components/Background";

export default {
  data: () => ({
    showModal: false,
    canCloseModal: false,
    wouldPlayAgainOptions: [
      {
        isSelected: false,
        option: "👎🏽",
      },
      {
        isSelected: false,
        option: "👍🏽",
      },
    ],
  }),
  components: {
    Background,
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      let eventName =
        process.env.VUE_APP_ANALYTICS_EVENT_BASE + "WouldPlayAgainFeedback";
      this.$logEvent(eventName, {
        wouldPlayAgain: this.wouldPlayAgainOptions[1].isSelected,
      });
      this.showModal = false;
    },
    showCloseModalButton() {
      this.canCloseModal = true;
    },
    goToFlourish() {
      if (window.nsWebViewBridge) {
        window.nsWebViewBridge.emit(
          "gameFinished",
          (this.rightAnswers / this.numOfQuestions) * 100
        );
        return;
      }
      let eventName =
        process.env.VUE_APP_ANALYTICS_EVENT_BASE + "OpenFlourishSite";
      this.$logEvent(eventName);
      window.open("https://flourishsavings.page.link/trcT");
    },
    playAgainSelection(index) {
      for (let i = 0; i < this.wouldPlayAgainOptions.length; i++) {
        this.wouldPlayAgainOptions[i].isSelected = index == i;
      }
      this.showCloseModalButton();
    },
  },
  computed: {
    performance() {
      return `${this.rightAnswers} / ${this.numOfQuestions}`;
    },
    numOfQuestions() {
      return this.$route.query.numOfQuestions;
    },
    rightAnswers() {
      return this.$route.query.rightAnswers;
    },
    reward() {
      return this.$route.query.coins;
    },
  },
  mounted() {
    let modal = setTimeout(() => {
      this.openModal();
      clearTimeout(modal);
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

@media only screen and (min-width: 600px) {
  .root {
    max-width: 375px;
  }
}

.root {
  min-width: 320px;
  min-height: 400px;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.2rem;
  flex-flow: column;
}

.behindModal {
  filter: blur(2px);
}

.flourish-logotipo {
  position: relative;
  top: 0;
  margin-top: 0.8rem;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 1.4rem;
}

.result-box {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  background-color: $quaternary-darker;
  border-radius: 1.4rem;
  padding: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  box-sizing: border-box;
}

.questionsAndReward {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.8rem;
}

.reward {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.8rem;
}

.questionsAndReward > .title {
  width: 100%;
  background-color: $primary;
  border-radius: 1.4rem;
  padding: 0.3rem 0.8rem;
  margin-bottom: 0.8rem;

  position: relative;
  font-family: $secondary-font;
  font-size: 1.4rem;
  text-align: center;
  color: $quaternary;
  box-sizing: border-box;
}

.questionsAndReward > .text,
.questionsAndReward > .reward > .text {
  position: relative;
  font-family: $secondary-font;
  font-size: 1.4rem;
  color: $primary-alternative;
  margin-right: 0.2rem;
}

.coin {
  border-radius: 48px;
  box-shadow: 0 4px 4px 0 rgba(#000, 0.4),
    0 6px 4px 0 rgba($quinternary-darker, 0.2);
}

.quote-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.quote {
  font-family: $primary-font;
  font-style: italic;
  font-size: 1.4rem;
  text-align: center;
  margin: 1rem 0 0 0;
  color: $quaternary-darker;
}

.author {
  font-family: $secondary-font;
  font-style: italic;
  font-size: 1.4rem;
  text-align: center;
  color: $quaternary-darker;
}

.footer {
  position: relative;
  margin-bottom: 2rem;
  box-shadow: 0 4px 4px 0 rgba(#000, 0.4),
    0 6px 4px 0 rgba($quinternary-darker, 0.2);
}

.isSelected {
  font-size: 2rem;
}

ul {
  padding: 0;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

li {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.6rem;
  text-align: center;
  font-size: 1.4rem;
  color: $secondary-darker;
  font-family: $secondary-font;
}

.modal {
  display: flex; /* Hidden by default */
  justify-content: center;
  align-items: center;
  position: absolute; /* Stay in place */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.feedback {
  position: absolute;
  top: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: $quaternary-darker;
  border-radius: 1.4rem;
  padding: 1rem;
  width: 80%;
  box-sizing: border-box;
}

.feedback > .title {
  width: 100%;
  position: relative;
  font-family: $primary-font;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.8rem;
  text-align: center;
  color: $primary;
  box-sizing: border-box;
}

.modal-button {
  margin: inherit 0;
  margin-bottom: 0.5rem;
}
</style>
